export default function InspectionService(location) {
  /* Keep an internal stack of inspections, which user may navigate through by popping and pushing. */
  const _stack = [];

  this.push = function (item) {
    _stack.push(item);
  };

  this.pop = function () {
    if (_stack.length === 0) return null;
    return _stack.pop();
  };

  this.peek = function () {
    return _stack[_stack.length - 1];
  };

  this.hasStack = function () {
    return _stack.length > 0 ? true : false;
  };

  this.generateInspectionUrl = function (
    to_equipment_id,
    to_time_period,
    to_operation_id
  ) {
    var baseUrl = "/";
    var finalUrl =
      baseUrl +
      "wizard/" +
      to_time_period +
      "/" +
      to_equipment_id +
      "/" +
      to_operation_id;
    return finalUrl;
  };

  this.extractTimePeriodFromPath = function (path) {
    // how to find time period, eg. monthy, daily etc. without knowing all that much about the URL structure. well, let's assume "wizard" is there...
    var matches = path.match(/\/wizard\/(.*?)\//);
    return matches[1];
  };
}
